import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { goToLogin, getUserAttributes } from '../../helpers';
import { useAddToBag } from '../../hooks/useAddToBag';
import useSwitchCurrentUserProject from '../../hooks/useSwitchCurrentUserProject';
import { materialsInQueueSelector } from '../../redux/selectors/commonSelector';
import {
  isProjectModalOpenSelector,
  projectModalEventLocationSelector,
} from '../../redux/selectors/projectsSelector';
import { setMaterialsInQueue } from '../../redux/sliceCreators/commonSlice';
import {
  setIsProjectModalOpen,
  setProjectModalEventLocation,
} from '../../redux/sliceCreators/projectsSlice';

// TODO: consider removing this component and using the callbacks directly in the components that need them
export const ProjectModalListener = () => {
  const isModalOpen = useSelector(isProjectModalOpenSelector);
  const projectModalEventLocation = useSelector(
    projectModalEventLocationSelector,
  );
  const materialsInQueue = useSelector(materialsInQueueSelector);
  const dispatch = useDispatch();
  const { addToBag } = useAddToBag();
  const { displayNotification } = useSwitchCurrentUserProject();
  const userData = getUserAttributes();

  useEffect(() => {
    window.addEventListener('res-create-project', handleSaveProject);
    window.addEventListener('close-mb-modal', handleCloseModal);
    return () => {
      window.removeEventListener('res-create-project', handleSaveProject);
      window.removeEventListener('close-mb-modal', handleCloseModal);
    };
  }, [materialsInQueue, isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      if (userData?.signin_token == null) {
        goToLogin();
        return;
      }
      window.dispatchEvent(
        new CustomEvent('open-create-project-modal', {
          detail: { eventLocation: projectModalEventLocation },
        }),
      );
    }
  }, [isModalOpen]);

  const handleSaveProject = async (e: CustomEvent) => {
    const { detail } = e;
    if (detail?.project_id != null) {
      dispatch(setIsProjectModalOpen(false));

      if (materialsInQueue?.length > 0) {
        // No validation needed here - the project has just been created and is valid
        await addToBag(materialsInQueue, detail?.project_id, detail);
        dispatch(setMaterialsInQueue([]));
        displayNotification(false);
      } else {
        displayNotification();
      }
    }
  };

  const handleCloseModal = () => {
    dispatch(setIsProjectModalOpen(false));
    dispatch(setProjectModalEventLocation(''));
  };

  return null;
};
